import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { DEFAULT_BREAKPOINTS_SELECCION, DEFAULT_BREAKPOINTS_RESULTADOS } from 'components/TalentsCarousel/constants/talentCarouselConstants';
//----------------------------------------------------------------------------------------
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { useSelector } from 'react-redux';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import './CarouselSeleccion.scss';
import axios from 'axios';
import SeleccionCard from './card/SeleccionCard';
import {showPlaceHolderorImg} from 'containers/MundialViews/utils/mundialUtils';
import { FaChevronDown, FaChevronLeft,FaChevronRight } from 'react-icons/fa';
SwiperCore.use([Pagination, Navigation]);

const CarouselSeleccion = ({
  carrousel,
  breakpointConfig = DEFAULT_BREAKPOINTS_SELECCION,
}) => {
  const [selecciones, setSelecciones] = useState([]);
  const nameCarousel = carrousel.name.replace(/-/g, ' ');
  const { isMobile } = useVerifyIsMobile(768);
  const {ribbon_team_placeholder_img:placeholderVcard} = useSelector(state=>state.asset)

  useEffect(() => {
    axios
      .get(
        'https://gracenoteclaro.akamaized.net/gsd/lookup/v1/leagues/GNA5MGHG2ZVX2RD/teams?language=es-ES&api_key=y368pewmkbqewyaha8xydgc5',
      )
      .then(res => {
        setSelecciones(res.data.teams);
      })
      .catch(e => console.log(e));
  }, []);

  return (
    <>
      <div className="players-carousel">
      <div className="players-carousel__header">
        <h2 className="players-carousel__header__title">{nameCarousel}</h2>
        <div className="players-carousel__header__navigation" />
      </div>
      <div className="chrevrones-back">
        <FaChevronLeft size={17} className="players-carousel__header__navigation__prev-bt" />
      </div>
      <div className="chrevrones-next">
        <FaChevronRight size={17} className="players-carousel__header__navigation__next-bt"  />
     
      </div>
      <Swiper
        className="mySwiper"
        navigation={{
          prevEl: '.players-carousel__header__navigation__prev-bt',
          nextEl: '.players-carousel__header__navigation__next-bt',
        }}
        breakpoints={breakpointConfig}
        initialSlide={11}
        spaceBetween={24}
        slidesPerView={1}
        loop={true}
        style={{ marginTop: isMobile ? 0 : 24 }}
        watchOverflow
      >
        {selecciones?.map(seleccion => (
          <SwiperSlide key={seleccion.id}>
            <SeleccionCard 
            imgSeleccion={showPlaceHolderorImg(seleccion.images.teamLogo,placeholderVcard)}
             nameSeleccion={seleccion.names.full}
             id={seleccion.id} /> 
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    
    </>

  );
};

export default CarouselSeleccion;
